export const getReadingTime = (readingTime: number) => {
	if (readingTime >= 5) {
		return 'tileBanner.timeToBeRead.pluralizeMore'
	} else if (readingTime >= 2) {
		return 'tileBanner.timeToBeRead.pluralize'
	} else {
		return 'tileBanner.timeToBeRead.singularize'
	}
}
